import createVueComponent from '../createVueComponent';

const ChevronsDown = createVueComponent('ChevronsDownIcon', [
  ['path', { d: 'm7 6 5 5 5-5', key: '1lc07p' }],
  ['path', { d: 'm7 13 5 5 5-5', key: '1d48rs' }],
]);

export default ChevronsDown;
